import Axios from "axios";
import {
    SET_MODULE_LIST,
    UNSET_MODULE_LIST
  } from "@/store/mutation-types";
import { saveUpdateModuleSetup, getModuleList, deleteModule  } from "@/store/api";
// initial state
const state = {
  getModuleList: [],
};

const getters = {
  getModuleList(state) {
    return state.getModuleList;
  },
};
const mutations = {
  [SET_MODULE_LIST](state, data) {
    state.getModuleList = data;
  },
  [UNSET_MODULE_LIST](state) {
    state.getModuleList = [];
  },

};

const actions = {

  saveUpdateModuleSetup({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateModuleSetup, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getModuleList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getModuleList, {branch_id:data})
        .then(function (response) {
          commit('SET_MODULE_LIST',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_MODULE_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  deleteModule({ state, commit }, data) {
    commit("SET_LOADING", {color: "warning"});
    return new Promise(function (resolve, reject) {
    Axios.post(deleteModule, {id:data})
        .then((response) => {
            resolve(response);  
        })
        .catch((error) => {
            reject(error)  
        })
        .then((always) => {
          commit("UNSET_LOADING");
        });
    });
  }


};

export default {
  state,
  getters,
  actions,
  mutations,
};
